import { TOOLTIP_DURATION, TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/types/customTooltip';

export const nutrientFieldsConfig = [
  {
    field: 'calories_in_kcal',
    label: 'ap_item_nutrients_popup_calories_field',
    unit: 'kcal',
    tooltip: {
      message: 'ap_item_nutrients_popup_calories_field_infotip',
      duration: TOOLTIP_DURATION.EXTRA_LARGE,
      position: TOOLTIP_POSITION.PORTAL,
      iconSize: 16,
    },
  },
  { field: 'total_fat_in_gram', label: 'ap_item_nutrients_popup_total_fat_field', unit: 'g' },
  { field: 'saturated_fat_in_gram', label: 'ap_item_nutrients_popup_saturated_fat_field', unit: 'g' },
  { field: 'trans_fat_in_gram', label: 'ap_item_nutrients_popup_trans_fat_field', unit: 'g' },
  { field: 'cholesterol_in_milligram', label: 'ap_item_nutrients_popup_cholesterol_field', unit: 'mg' },
  { field: 'sodium_in_milligram', label: 'ap_item_nutrients_popup_sodium_field', unit: 'mg' },
  { field: 'carbohydrate_in_gram', label: 'ap_item_nutrients_popup_carbohydrates_field', unit: 'g' },
  { field: 'fiber_in_gram', label: 'ap_item_nutrients_popup_fiber_field', unit: 'g' },
  { field: 'total_sugars_in_gram', label: 'ap_item_nutrients_popup_total_sugars_field', unit: 'g' },
  { field: 'added_sugars_in_gram', label: 'ap_item_nutrients_popup_added_sugars_field', unit: 'g' },
  { field: 'protein_in_gram', label: 'ap_item_nutrients_popup_protein_field', unit: 'g' },
  { field: 'polyols_in_gram', label: 'ap_item_nutrients_popup_polyols_field', unit: 'g' },
  { field: 'salt_in_gram', label: 'ap_item_nutrients_popup_salt_field', unit: 'g' },
];
